import React, { useEffect } from "react";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import { DocumentScanner } from "@mui/icons-material";
import { useRef } from "react";
import "jspdf-autotable";
import { formatSignatureDate } from "../../../utils/formatSignatureDate";
import { connect } from "react-redux";
import moment from "moment";
import { imageToBase64 } from "../../../utils/imageToBase64";
import { uploadCRMDocumentAndGetUrl } from "../../../utils/uploadDocument";
import { post } from "../../../api";

export const generatePDF = async (data, user, sasToken, isSendToTalentTrail = false, token, candidateId) => {
  const doc = new jsPDF();
  doc.setFont("helvetica", "bold");
  doc.setFontSize(16);
  doc.text("Work Experience", 105, 30, { align: "center" });

  doc.setFont("helvetica", "bold");
  doc.setFontSize(14);
  doc.text("Personal Information", 105, 50, { align: "center" });

  // Reference 1 Section
  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("Reference 1", 10, 80);

  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("Company Name & Your Job Title", 10, 90);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.text(`${data?.companyName1}`, 10, 95);

  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("Contact Name", 10, 105);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.text(`${data?.contactName1}`, 10, 110);

  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("Address", 10, 120);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.text(`${data?.address1}`, 10, 125);

  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("Postcode", 10, 135);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.text(`${data?.postcode1}`, 10, 140);

  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("Email", 10, 150);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.text(`${data?.email1}`, 10, 155);

  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("Telephone", 10, 165);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.text(`${data?.telephone1}`, 10, 170);

  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("Date of Employment", 10, 180);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.text(`${data?.dateOfEmployment1}`, 10, 185);

  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("You wish to be approached before this person is contacted", 10, 195);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.text(`${data?.wishApproached1 ? "Yes" : "No"}`, 10, 200);

  // Page 2 for Reference 2 Section
  doc.addPage();

  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("Reference 2", 10, 10);

  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("Company Name & Your Job Title", 10, 20);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.text(`${data?.companyName2}`, 10, 25);

  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("Contact Name", 10, 35);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.text(`${data?.contactName2}`, 10, 40);

  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("Address", 10, 50);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.text(`${data?.address2}`, 10, 55);

  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("Postcode", 10, 65);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.text(`${data?.postcode2}`, 10, 70);

  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("Email", 10, 80);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.text(`${data?.email2}`, 10, 85);

  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("Telephone", 10, 95);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.text(`${data?.telephone2}`, 10, 100);

  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("Date of Employment", 10, 110);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.text(`${data?.dateOfEmployment2}`, 10, 115);

  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("You wish to be approached before this person is contacted", 10, 125);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.text(`${data?.wishApproached2 ? "Yes" : "No"}`, 10, 130);

  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("CV / Previous Employment History", 10, 140);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.text(`${data?.previousEmploymentHistory?.name || "N/A"}`, 10, 145);

  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("PSchool/University History", 10, 155);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.text(`${data?.schoolUniversityHistory?.name || "N/A"}`, 10, 160);


  // Add signature and consent information on a new page
  doc.addPage();
  let currentHeight = 20;
  const pageWidth = doc.internal.pageSize.width;
  const margin = 10;

  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("Signable Form Title", margin, currentHeight);
  doc.setFont("helvetica", "normal");
  doc.text("Work Experience", pageWidth * 0.4, currentHeight);
  currentHeight += 10;

  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("Signable Form Provided by", margin, currentHeight);
  doc.setFont("helvetica", "normal");
  doc.text("Rapid Resourcing", pageWidth * 0.4, currentHeight);
  currentHeight += 10;

  doc.line(margin, currentHeight, pageWidth - margin, currentHeight);
  currentHeight += 10;

  const paragraphText = `By signing this page, I confirm that I fully understand the content and agree to adhere to it at all times. I also agree that all the details provided in this document are accurate and complete to the best of my knowledge.`;
  const paragraphLines = doc.splitTextToSize(paragraphText, pageWidth - 2 * margin);
  doc.setFontSize(10);
  doc.text(paragraphLines, margin, currentHeight);
  currentHeight += 20;

  const paragraphText2 = `By ticking this box I consent to the company processing my data and the evidence of this document being stored within their system for the purpose of work finding services.`;
  const paragraphLines2 = doc.splitTextToSize(paragraphText2, pageWidth - 2 * margin);
  doc.text(paragraphLines2, margin, currentHeight);
  currentHeight += 40;

  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("Date Signed", margin, currentHeight);
  doc.setFont("helvetica", "normal");
  doc.text(`${data?.signDate ? moment(data?.signDate).format("DD-MM-YYYY") : '--'}`, pageWidth * 0.4, currentHeight);
  currentHeight += 10;

  // Add signature image from URL
  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("Signature", margin, currentHeight);

  // Add the signature image if the URL exists
  if (data?.signature) {
    try {
      const imgData = await imageToBase64(`${data.signature}?${sasToken}`);
      doc.addImage(imgData, "JPEG", pageWidth * 0.4, currentHeight, 30, 15);
    } catch (e) {
      console.error("Error loading signature image:", e);
    }
  }
  currentHeight += 20;

  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("Name", margin, currentHeight);
  doc.setFont("helvetica", "normal");
  doc.text(`${user?.firstName} ${user?.lastName}`, pageWidth * 0.4, currentHeight);
  currentHeight += 10;

  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("IP Address", margin, currentHeight);
  doc.setFont("helvetica", "normal");
  doc.text(`${data?.ipAddress}`, pageWidth * 0.4, currentHeight);
  currentHeight += 10;

  // Save the PDF
  if (isSendToTalentTrail) {
    const pdfBlob = doc.output("blob");
    const formData = new FormData();
    formData.append(
      "file",
      pdfBlob,
      `work-experience-${user?.firstName}-${user?.lastName}.pdf`
    );
    formData.append("candidateId", candidateId);
    const documentUrl =
      (await uploadCRMDocumentAndGetUrl(formData, token)) || "";
    console.log("documentUrl", documentUrl);
    if (documentUrl) {
      const payload = {
        candidateId,
        fileName: `work-experience-${user?.firstName}-${user?.lastName}.pdf`,
        fileExtention: ".pdf",
        fileType: "workExperience",
        fileLink: documentUrl,
        licenseNo: "rapidresourcing",
      };

      const url = "/api/candidate/save-document";
      try {
        const res2 = await post(url, payload);
        console.log("Document saved successfully:", res2.data);
      } catch (error) {
        console.error("Error saving document:", error);
      }
    } else {
      console.error("Failed to upload document, skipping save.");
    }
  } else {
    doc.save(`work-experience-${user?.firstName}-${user?.lastName}.pdf`);
  }
};

const WorkExperienceDownload = ({ data, sasToken, user }) => {
  const signatureRef = useRef(null); // Create a reference to the image element
  useEffect(() => {
    if (signatureRef.current) {
      // Set the crossOrigin attribute to allow cross-origin image loading
      signatureRef.current.crossOrigin = 'anonymous';
    }
  }, []);
  
  return (
    <>
      <div className="text-center p-4 document-sign">
        <p>{formatSignatureDate(data?.signDate, user)}</p>
        <div>
          {data?.signature && (
            <img ref={signatureRef} src={`${data?.signature}?${sasToken}`} />
          )}
        </div>
      </div>
      <div className="text-center w-100 mt-4">
        <button className="btn btn-success btn-lg" onClick={() => generatePDF(data, user, sasToken)}>
          <DocumentScanner /> Download your receipt
        </button>
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({});
export default connect(mapStateToProps, {})(WorkExperienceDownload);
